import { useContext } from 'react';

import { AuthContext } from './AuthProvider';

export default () => useContext(AuthContext);
